import React, { useState } from 'react'
import FsLightbox from 'fslightbox-react'

import Slider from 'react-slick'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import './PropertySlider.scss'

const PropertySlider = (props: any) => {
  const [carousel, setCarousel] = useState<null | any>(null)
  const [lightboxController, setLightboxController] = useState({
    toggler: false,
    slide: 1
  })

  const next = () => {
    if (carousel) {
      carousel.slickNext()
    }
  }
  const prev = () => {
    if (carousel) {
      carousel.slickPrev()
    }
  }

  function openLightboxOnSlide(number: number) {
    setLightboxController({
      toggler: !lightboxController.toggler,
      slide: number
    })
  }

  const isYoutube = (link: string) => {
    let result
    let patterns = ['youtu.be', 'youtube.com']

    patterns.forEach((pattern: any) => {
      if (link.includes(pattern)) {
        result = true
      } else {
        result = false
      }
    })

    return result
  }

  const isImg = (link: string) => {
    const regex = /(?:jpg|jpeg|gif|png|PNG|JPG|JPEG|GIF)/g
    let isImg = link.search(regex)

    if (isImg > 0) {
      return true
    }
    return false
  }

  // Get all items that are youtube links and image only
  const gallerySliders = props.images.filter((item: string) => isYoutube(item) || isImg(item))

  const settings = {
    className: 'properties-slider',
    dots: false,
    infinite: true,
    centerMode: false,
    initialSlide: 1,
    slidesToShow: gallerySliders && gallerySliders.length < 3 ? 1 : 3,
    slidesToScroll: 1,
    arrows: false
  }

  let ItemTypes = gallerySliders.map((item: any) => (isYoutube(item) ? 'youtube' : 'image'))

  const VideoPlaceHolder = () => {
    var min = 0
    var max = gallerySliders.length - 1
    var random = Math.floor(Math.random() * (+max - +min)) + +min

    let thumbnail = gallerySliders[random]
    return (
      <div
        className="video-placeholder"
        style={{
          background: `linear-gradient(rgba(51, 117, 77, 0.699), #000), url('${thumbnail}') center`,
          backgroundSize: `cover`
        }}
      >
        <i className="la la-play-circle"></i>
      </div>
    )
  }

  return (
    <>
      {gallerySliders && (
        <FsLightbox toggler={lightboxController.toggler} slide={lightboxController.slide} types={ItemTypes} sources={gallerySliders} />
      )}
      <div className="property-slider fade-in dl-2">
        <Slider ref={(c) => setCarousel(c)} {...settings}>
          {gallerySliders.length !== 0 &&
            gallerySliders.map((item: any, index: number) => {
              if (isYoutube(item) || isImg(item)) {
                return (
                  <div
                    className="property-slide"
                    key={index}
                    onClick={() => {
                      openLightboxOnSlide(index + 1)
                    }}
                  >
                    <div className="slide-content">
                      {isYoutube(item) ? <VideoPlaceHolder /> : <img src={item} alt="featured properties" />}
                      {/* <div className="slide-text">
                      <div>
                        <small>House & Lot</small>
                        <span>Patio Suites Abreeza</span>
                      </div>
                    </div> */}
                    </div>
                  </div>
                )
              }
            })}
        </Slider>

        <div className="property-arrows">
          <div className="property-slider-arrow arrow-1" onClick={next}>
            <i className="la la-angle-left la-2x" />
          </div>
          <div className="property-slider-arrow arrow-2" onClick={prev}>
            <i className="la la-angle-right la-2x" />
          </div>
        </div>
      </div>
    </>
  )
}

export default PropertySlider
